import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalHelper } from '../Common/global.service';

@Injectable({
  providedIn: 'root'
})
export class ExamService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }

  // Class Wise subject Mark

  GetClassSectionStreamByStaffID(SessionID, ScoreTypeIDs): Observable<any> {
    let param = 'SessionID=' + SessionID + '&ScoreTypeIDs=' + ScoreTypeIDs

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/GetClassSectionStreamByStaffID?' + encodeURI(param), { headers: reqHeader });
  }
  GetClassWiseSubjectMark(strdata: any): Observable<any> {
    let param = 'objExam=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/GetClassWiseSubjectMark?' + encodeURI(param), { headers: reqHeader });
  }

  SaveClassWiseSubjectMark(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("objGridValue", data);
    formData.append("list", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/SaveClassWiseSubjectMark', formData);
  }

  GetDiscipline(strdata: any): Observable<any> {
    let param = 'Strdata=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetDiscipline?' + encodeURI(param), { headers: reqHeader });
  }

  SaveDiscipline(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("StrData", data);
    formData.append("StudentList", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveDiscipline', formData);
  }

  GetClassTeacherRemarks(strdata: any): Observable<any> {
    let param = 'Strdata=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetClassTeacherRemarks?' + encodeURI(param), { headers: reqHeader });
  }

  SaveClassTeacherRemarks(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("StrData", data);
    formData.append("StudentList", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveClassTeacherRemarks', formData);
  }


  GetCoScholasticAssessment(strdata: any): Observable<any> {
    let param = 'objsetup=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/GetCoScholasticAssessment?' + encodeURI(param), { headers: reqHeader });
  }


  SaveCoScholasticAssessment(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("objAccessmentSetup", data);
    formData.append("AccessmentCCESetUpList", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/SaveCoScholasticAssessment', formData);
  }

  GetExamCoScholasticStudentSetup(TermID, ClassID, SectionID, SubjectID): Observable<any> {
    let param = 'TermID=' + TermID + '&ClassID=' + ClassID + '&SectionID=' + SectionID + '&SubjectID=' + SubjectID
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/GetExamCoScholasticStudentSetup?' + encodeURI(param), { headers: reqHeader });
  }


  SaveExamCoScholasticStudentSetup(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("objStudentElective", data);
    formData.append("strStudentlist", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/SaveExamCoScholasticStudentSetup', formData);
  }

  GetExamStudentPromotionRemarks(ClassID, SectionID, SessionID): Observable<any> {
    let param = 'ClassID=' + ClassID + '&SectionID=' + SectionID + '&SessionID=' + SessionID
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/GetExamStudentPromotionRemarks?' + encodeURI(param), { headers: reqHeader });
  }

  SaveExamStudentPromotionRemarks(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("PromotionRemarksModel", data);
    formData.append("StudentList", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/SaveExamStudentPromotionRemarks', formData);
  }

  GetStudentByHealth(ExamMapID, ClassID, SectionID, TermID): Observable<any> {
    let param = 'ExamMapID=' + ExamMapID + '&ClassID=' + ClassID + '&SectionID=' + SectionID + '&TermID=' + TermID
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/GetStudentByHealth?' + encodeURI(param), { headers: reqHeader });
  }

  SaveAssessmentHealthStudent(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("AssessmentHealthModel", data);
    formData.append("StudentList", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/SaveAssessmentHealthStudent', formData);
  }

  GetStudentByFeedBack(TermID, ClassID, SectionID, ExamMapID): Observable<any> {
    let param = 'TermID=' + TermID + '&ClassID=' + ClassID + '&SectionID=' + SectionID + '&ExamMapID=' + ExamMapID
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/GetStudentByFeedBack?' + encodeURI(param), { headers: reqHeader });
  }

  GetAssessmentLangByClassID(TermID, SectionID): Observable<any> {
    let param = 'ClassID=' + TermID + '&SectionID=' + SectionID
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/GetAssessmentLangByClassID?' + encodeURI(param), { headers: reqHeader });
  }

  SaveAssessmentFeedbackStudent(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("AssessmentFeedbackModel", data);
    formData.append("StudentList", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/SaveAssessmentFeedbackStudent', formData);
  }

  GetStudentElectiveByClassID(TermID, ClassID, SubjectID): Observable<any> {
    let param = 'ClassID=' + TermID + '&SectionID=' + ClassID + '&SubjectID=' + SubjectID
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/GetStudentElectiveByClassID?' + encodeURI(param), { headers: reqHeader });
  }

  SaveStudentElective(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("objStudentElective", data);
    formData.append("strStudentlist", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/SaveStudentElective', formData);
  }

  GetStudentScoreCard(ClassID, SectionID, ReportType, TermID): Observable<any> {
    let param = 'ClassID=' + ClassID + '&SectionID=' + SectionID + '&ReportType=' + ReportType + '&TermID=' + TermID;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/GetStudentScoreCard?' + encodeURI(param), { headers: reqHeader });
  }

  SearchGradedScoreCard(ClassID, SectionID, SubjectID, PersonalSkillID): Observable<any> {
    let param = 'ClassID=' + ClassID + '&SectionID=' + SectionID + '&ExamMapID=' + SubjectID + '&PersonalSkillID=' + PersonalSkillID
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/SearchGradedScoreCard?' + encodeURI(param), { headers: reqHeader });
  }

  SaveGradedScoreCard(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("GradedScoreCardModel", data);
    formData.append("GradedScoreCardList", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/SaveGradedScoreCard', formData);
  }

  SaveMarkGrading(strdata: any): Observable<any> {
    let param = 'objgrade=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveMarkGrading?' + encodeURI(param), { headers: reqHeader });
  }


  SearchExamScheduleSetup(strdata: any): Observable<any> {
    let param = 'objExam=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SearchExamScheduleSetup?' + encodeURI(param), { headers: reqHeader });
  }

  GetAcademicReport(strdata: any): Observable<any> {
    let param = 'stidentscorecardModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Examination/GetAcademicReport?' + encodeURI(param), { headers: reqHeader });
  }

  SaveExamScheduleSetup(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("objSaveExam", data);
    formData.append("strlist", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveExamScheduleSetup', formData);
  }


  Share(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("objSaveExam", data);
    formData.append("list", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/Share', formData);
  }

  SavePerssonalSkillActivityMap(objSaveExam, strlist): Observable<any> {
    let param = 'ClassID=' + objSaveExam + '&PerssonalSkillActivityList=' + strlist
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/SavePerssonalSkillActivityMap?' + encodeURI(param), { headers: reqHeader });
  }

  GetPerssonalSkillActivityMap(strdata: any): Observable<any> {
    let param = 'ClassID=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/GetPerssonalSkillActivityMap?' + encodeURI(param), { headers: reqHeader });
  }

  SavePersonalSkillActivity(strdata: any): Observable<any> {
    let param = 'objActivity=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/SavePersonalSkillActivity?' + encodeURI(param), { headers: reqHeader });
  }

  SearchAllPersonalSkill(): Observable<any> {

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/SearchAllPersonalSkill', { headers: reqHeader });
  }

  GetPersonalSkillActivityStaffMap(strdata: any): Observable<any> {
    let param = 'strdata=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/GetPersonalSkillActivityStaffMap?' + encodeURI(param), { headers: reqHeader });
  }

  SavePersonalSkillActivityStaffMap(strdata: any): Observable<any> {
    let param = 'strdata=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/SavePersonalSkillActivityStaffMap?' + encodeURI(param), { headers: reqHeader });
  }

  DeletePersonalSkill(strdata: any): Observable<any> {
    let param = 'ExamActStaffMapIDs=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/DeletePersonalSkill?' + encodeURI(param), { headers: reqHeader });
  }

  SaveExamClassAchievementScaleMap(file, data): Observable<any> {
    let formData = new FormData();
    formData.append("objExamClassMap", data);
    formData.append("strClassMaplist", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveExamClassAchievementScaleMap', formData);
  }

  GetExamClassAchievementScaleMap(strdata: any): Observable<any> {
    let param = 'ClassID=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetExamClassAchievementScaleMap?' + encodeURI(param), { headers: reqHeader });
  }


  // Personal Skill Master
  SavePersonalSkill(strdata: any): Observable<any> {
    let param = 'objPersonalSkill=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/SavePersonalSkill?' + encodeURI(param), { headers: reqHeader });
  }

  GetAllPersonalSkill(): Observable<any> {

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'ExamAccessment/GetAllPersonalSkill', { headers: reqHeader });
  }

  SaveExamScale(strdata: any): Observable<any> {

    let param = 'objExamScaleMaster=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveExamScale?' + encodeURI(param), { headers: reqHeader });
  }

  GetAllExamScaleMaster(): Observable<any> {

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetAllExamScaleMaster', { headers: reqHeader });
  }

  GetAllMarkGrade(): Observable<any> {

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetAllMarkGrade', { headers: reqHeader });
  }


  SaveClassTermMap(file, data): Observable<any> {

    let formData = new FormData();
    formData.append("objList", file);
    formData.append("ClassID", data);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveClassTermMap', formData);
  }


  GetClassTermMap(strdata: any): Observable<any> {

    let param = 'ClassID=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetClassTermMap?' + encodeURI(param), { headers: reqHeader });
  }

  SaveExamClassMap(file, data): Observable<any> {

    let formData = new FormData();
    formData.append("objExamClassMap", data);
    formData.append("strClassMaplist", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveExamClassMap', formData);
  }

  SaveSubExamClassMap(file, data): Observable<any> {


    let formData = new FormData();
    formData.append("objExamClassMap", data);
    formData.append("strClassMaplist", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveSubExamClassMap', formData);
  }

  GetExamClassMap(classId, termId): Observable<any> {

    let param = 'ClassID=' + classId + '&TermID=' + termId;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetExamClassMap?' + encodeURI(param), { headers: reqHeader });
  }

  GetSubExamClassMap(ClassID, TermID, ExamMapID): Observable<any> {

    let param = 'ClassID=' + ClassID + '&TermID=' + TermID + '&ExamMapID=' + ExamMapID;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetSubExamClassMap?' + encodeURI(param), { headers: reqHeader });
  }

  SaveTerm(strdata: any): Observable<any> {
    let param = 'ObjExam=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveTerm?' + encodeURI(param), { headers: reqHeader });
  }

  GetAllTerm(): Observable<any> {

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetAllTerm', { headers: reqHeader });
  }

  GetScoreCardType(): Observable<any> {


    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetScoreCardType', { headers: reqHeader });
  }

  SaveExam(strdata: any): Observable<any> {
    let param = 'ObjExam=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveExam?' + encodeURI(param), { headers: reqHeader });
  }

  GetAllExamMaster(): Observable<any> {

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetAllExamMaster', { headers: reqHeader });
  }

  SaveExamScoreCardTypeClassMap(strdata: any): Observable<any> {
    let param = 'ObjScoreCard=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveExamScoreCardTypeClassMap?' + encodeURI(param), { headers: reqHeader });
  }

  GetExamScoreCardTypeClassMap(): Observable<any> {

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetExamScoreCardTypeClassMap', { headers: reqHeader });
  }

  SaveExamSchedule(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("strdata", data);
    formData.append("ClassScheduleList", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveExamSchedule', formData);
  }

  GetExamSchedule(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetExamSchedule', { headers: reqHeader });
  }

  GetScheduleClass(strdata: any): Observable<any> {
    let param = 'ExamScheduleID=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetScheduleClass?' + encodeURI(param), { headers: reqHeader });
  }

  GetExamSubjectScheduleSetup(strdata: any): Observable<any> {
    let param = 'objExam=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetExamSubjectScheduleSetup?' + encodeURI(param), { headers: reqHeader });
  }

  SaveExamSubjectScheduleSetup(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("objSaveExam", data);
    formData.append("strlist", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveExamSubjectScheduleSetup', formData);
  }

  GetStudentAdmitCard(strdata: any): Observable<any> {
    let param = 'strStudent=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetStudentAdmitCard?' + encodeURI(param), { headers: reqHeader });
  }

  GetStudentAdmitCardDetails(strdata: any): Observable<any> {
    let param = 'strModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetStudentAdmitCardDetails?' + encodeURI(param), { headers: reqHeader });
  }

  // Grade Scale 

  SaveGradeScale(strdata: any): Observable<any> {
    let param = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveGradeScale?' + encodeURI(param), { headers: reqHeader });
  }

  GetAllGradeScale(): Observable<any> {

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetAllGradeScale', { headers: reqHeader });
  }

  // Grade Scale Class Map 

  SaveGradeScaleClassMap(strdata: any): Observable<any> {
    let param = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveGradeScaleClassMap?' + encodeURI(param), { headers: reqHeader });
  }

  GetGradeScaleClassMap(): Observable<any> {

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetGradeScaleClassMap', { headers: reqHeader });
  }


  // Discipline Master

  SaveDisciplineMaster(strdata: any): Observable<any> {
    let param = 'ObjExam=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveDisciplineMaster?' + encodeURI(param), { headers: reqHeader });
  }

  GetDisciplineMaster(): Observable<any> {

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/GetDisciplineMaster', { headers: reqHeader });
  }

  DisciplineMasterActive(strdata: any): Observable<any> {
    let param = 'ObjExam=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/DisciplineMasterActive?' + encodeURI(param), { headers: reqHeader });
  }

  // Discipline Class Mapping

  SearchDisciplineClassMapping(strdata: any): Observable<any> {
    let param = 'ObjExam=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SearchDisciplineClassMapping?' + encodeURI(param), { headers: reqHeader });
  }

  SaveDisciplineClassMapping(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("objSaveExam", data);
    formData.append("strlist", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/SaveDisciplineClassMapping', formData);
  }

  ShareDisciplineClassMapping(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("objSaveExam", data);
    formData.append("list", file);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/ShareDisciplineClassMapping', formData);
  }

  ExamMarkActive(ExamID: any,IsActive:any): Observable<any> {

    let formData = new FormData();
    formData.append("ExamID", ExamID);
    formData.append("IsActive", IsActive);
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Exam/ExamMarkActive', formData);
  }
  GetExamStudentScoreCardrps(data): Observable<any> {
    let formData = new FormData();
    formData.append("stidentscorecardModel", data);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Examination/GetExamStudentScoreCardrps', formData);
  }
  
  GetExamStudentScoreCard12(data): Observable<any> {
    let formData = new FormData();
    formData.append("stidentscorecardModel", data);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Examination/GetExamStudentScoreCard12', formData);
  }
  GetDepsExamStudentScoreCard12(data): Observable<any> {
    let formData = new FormData();
    formData.append("stidentscorecardModel", data);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Examination/GetDepsExamStudentScoreCard12', formData);
  }
  
  GetExamStudentScoreCardTerm1(data): Observable<any> {
    let formData = new FormData();
    formData.append("stidentscorecardModel", data);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Examination/GetExamStudentScoreCardTerm1', formData);
  }

  GetExamMppsgScoreCardTerm1(data): Observable<any> {
    let formData = new FormData();
    formData.append("stidentscorecardModel", data);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Examination/GetExamMppsgScoreCardTerm1', formData);
  }
  GetExamMppsgScoreCardTerm2(data): Observable<any> {
    let formData = new FormData();
    formData.append("stidentscorecardModel", data);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Examination/GetExamMppsgScoreCardTerm2', formData);
  }
  GetExamStudentScoreCardExamWise(data): Observable<any> {
    let formData = new FormData();
    formData.append("stidentscorecardModel", data);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Examination/GetExamStudentScoreCardExamWise', formData);
  }
  GetExamStudentScoreCardTerm2(data): Observable<any> {
    let formData = new FormData();
    formData.append("stidentscorecardModel", data);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Examination/GetExamStudentScoreCardTerm2', formData);
  }


}